var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-item user-msg user-img"},[_c('svg-icon',{staticClass:"icon-user",attrs:{"icon-class":"icon-yonghu1"}}),_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content-body"},[_c('img',{attrs:{"src":_vm.message}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }